module.exports = __webpack_public_path__ + "static/gallery_kerry_1_thumb-1c191ca84ef3942f250a758796c580b3.jpg";